export enum PaymentMethodsCode {
  PREPAID = 'PREPAID',
  PAY_AT_DESTINATION = 'PAY_AT_DESTINATION',
}
